import React from 'react';

export const Button = props => {
  let icon = null;
  let value = props.defaultText;

  if (props.icon) {
    icon = <i className={`fa ${props.icon}`}></i>;
  }

  if (props.isbusy) {
    value = props.busyText;
    icon = <i className="fa fa-circle-o-notch m2spin"></i>;
  }

  let className = 'Button';
  if (props.size) {
    className = `Button-${props.size}`;
  }
  if (props.danger) {
    className = `${className} Button-danger`;
  }

  const activeButton = (
    <div className={className} onClick={props.onClick}>
      <button disabled={props.isbusy}>
        {' '}
        {icon} {value}{' '}
      </button>
    </div>
  );

  const disabledButton = (
    <div className="Button-disabled">
      <button disabled>
        {' '}
        {icon} {value}
      </button>
    </div>
  );

  let currentButton;

  if (props.insufficientData) {
    currentButton = disabledButton;
  } else {
    currentButton = activeButton;
  }

  return <div>{currentButton}</div>;
};



// WEBPACK FOOTER //
// ./src/components/shared/Button.js